import styled from '@emotion/styled';

type Props = {
  title: string;
  className?: string;
};

export const SettingsTitle = ({ title, className }: Props) => {
  return <Root className={className}>{title}</Root>;
};

const Root = styled.h1({
  margin: '0 0 20px 0',
  fontSize: 22,
  fontFamily: 'var(--font-bold)',
  color: 'var(--black)',
  fontWeight: 'normal',
  lineHeight: '45px',
  width: '100%',
  borderBottom: '1px solid var(--gray-l)',
  boxShadow: '0 1px 0 0 var(--sec-01)',
});
